module.exports = __webpack_public_path__ + "img/frame (192).fed2bec6.jpg";